import Delegate from "//legramme.com/cdn/shop/t/78/assets/ftdomdelegate.min.js?v=167457923630348017651773307050";

export class LoginSection extends HTMLElement {
    connectedCallback() {

      this.loginForm = this.querySelectorAll('[data-element="login-form"]');
      this.resetForm = this.querySelectorAll('[data-element="reset-form"]');
  
      this._attachListeners();
      this._initSection();

      console.log('HERE');

      // check for referrer to redirect on the good page
      if(sessionStorage.getItem('lg-redirection') !== null){
        let loginForm = document.querySelector("#customer-login-form");
        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        input.value = sessionStorage.getItem('lg-redirection');

        if(loginForm){
          loginForm.prepend(input);
        }
      }
  
    }
  
    _attachListeners() {
        new Delegate(this).on('click', '[data-action="toggle-form"]', this._toggleForm.bind(this));
    }
  
    _initSection() {
      if (location.hash === "#recover") {
        if (this.loginForm && this.resetForm) {
          this.loginForm.forEach(function(value, index) {
            value.classList.add('hidden');
          });
          this.resetForm.forEach(function(value, index) {
            value.classList.remove('hidden')
          })
        }
      } else {
        if (this.loginForm && this.resetForm) {
          this.loginForm.forEach(function(value, index) {
            value.classList.remove('hidden');
          });
          this.resetForm.forEach(function(value, index) {
            value.classList.add('hidden')
          })
        }
      }
    }
  
    _toggleForm() {
      if (this.loginForm && this.resetForm) {
        this.loginForm.forEach(function(value, index) {
          value.classList.toggle('hidden');
        });
        this.resetForm.forEach(function(value, index) {
          value.classList.toggle('hidden');
        })
      }
    }
  
}
try {
  window.customElements.define('login-section', LoginSection);
} catch(e) {}